// src/view/screens/Profile/Profile.js
import React, { useEffect, useState, useRef } from "react";
import "./Profile.scss";
import { ReactComponent as Coin } from "../../../assets/svg/coin.svg";
import { ReactComponent as Edit } from "../../../assets/svg/edit.svg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Notification } from "./../../../assets/svg/notification.svg";
import { ReactComponent as Gear } from "./../../../assets/svg/gear.svg";
import { ReactComponent as Exit } from "./../../../assets/svg/exit.svg";
import { ReactComponent as Doc } from "./../../../assets/svg/doc.svg";
import { ReactComponent as Help } from "./../../../assets/svg/help.svg";
import PopUpExcludedAccount from "../../components/PopUpExcludedAccount/PopUpExcludedAccount";
import { useTranslation } from "react-i18next";
import { useAuthValidation } from "../../../hooks/useAuthValidation";
import api from "../../../services/api";
import DefaultLayout from "../../components/Layouts/DefaultLayout";

function Profile() {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [imageProfile, setImageProfile] = useState("");
  const [imageCover, setImageCover] = useState("");
  const [userCoins, setUserCoins] = useState(0);
  const [userPoints, setUserPoints] = useState(0);
  const [profileValue, setProfileValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fileInputProfileRef = useRef(null);
  const fileInputCoverRef = useRef(null);
  const type = localStorage.getItem("typeUser");

  useEffect(() => {
    if (user) {
      setUserData(user);
      setImageProfile(user.images?.avatar?.link || "");
      setImageCover(user.images?.cover?.link || "");
      setUserCoins(Number(user.rewards?.coins) || 0);
      setUserPoints(Number(user.rewards?.points) || 0);
      setProfileValue(user.profile?.value || "");
    }
  }, [user]);

  // Primeiro chamamos todos os hooks, depois fazemos o return condicional.

  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  if (!user) {
    return null;
  }

  const handleLogout = async () => {
    try {
      await api.post("/logout");
      localStorage.removeItem("token");
      localStorage.removeItem("typeUser");
      navigate("/");
    } catch (error) {
      console.error("Erro ao deslogar:", error);
    }
  };

  const updateUserData = async () => {
    try {
      const response = await api.get("/user");
      const updatedUser = response.data;
      setUserData(updatedUser);
      setImageProfile(updatedUser.images?.avatar?.link || "");
      setImageCover(updatedUser.images?.cover?.link || "");
      setUserCoins(Number(updatedUser.rewards?.coins) || 0);
      setUserPoints(Number(updatedUser.rewards?.points) || 0);
      setProfileValue(updatedUser.profile?.value || "");
    } catch (error) {
      console.error("Erro ao atualizar dados do usuário:", error);
    }
  };

  const handleProfileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);

    try {
      await api.post("/user/update/image/profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      await updateUserData();
    } catch (error) {
      console.error("Erro ao enviar a imagem de perfil:", error);
    }
  };

  const handleCoverChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);

    try {
      await api.post("/user/update/image/cover", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      await updateUserData();
    } catch (error) {
      console.error("Erro ao enviar a imagem de capa:", error);
    }
  };

  const handleProfileClick = () => {
    fileInputProfileRef.current.click();
  };

  const handleCoverClick = () => {
    fileInputCoverRef.current.click();
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <DefaultLayout>
      <section className="profile">
        <div className="container">
          <div className="profile-information">
            <div>
              <div style={{ backgroundImage: `url(${imageCover})` }} className="cover-image">
                <input
                  type="file"
                  id="input-cover-image"
                  ref={fileInputCoverRef}
                  onChange={handleCoverChange}
                  style={{ display: "none" }}
                />
                <button type="button" onClick={handleCoverClick}>
                  <Edit />
                </button>
              </div>
              <div className="profile-image">
                <img src={imageProfile} alt={t("profile-image-alt")} />
                <input
                  type="file"
                  id="input-profile-image"
                  ref={fileInputProfileRef}
                  onChange={handleProfileChange}
                  style={{ display: "none" }}
                />
                <button type="button" onClick={handleProfileClick}>
                  <Edit />
                </button>
              </div>
            </div>
            <h1>{userData?.name}</h1>
            <span>{profileValue}</span>
          </div>
          <div className="achievements">
            {type !== "promoter" && (
              <div className="coins row">
                <span>Coins:</span>
                <Coin />
                <span className="coin">{userCoins}</span>
              </div>
            )}
          </div>
          <ul className="buttons-options">
            <li>
              <Link to="/notificacao">
                <Notification />
                <span>{t("profile-button-1")}</span>
              </Link>
            </li>
            <li>
              <Link to="/documentos-enviados">
                <Doc />
                <span>{t("profile-button-2")}</span>
              </Link>
            </li>
            <li>
              <Link to="/editar-dados">
                <Gear />
                <span>{t("profile-button-3")}</span>
              </Link>
            </li>
            <li>
              <Link to="/editar-endereco">
                <Gear />
                <span>{t("profile-button-4")}</span>
              </Link>
            </li>
            <li>
              <Link to="/alterar-senha">
                <Gear />
                <span>{t("profile-button-5")}</span>
              </Link>
            </li>
            <li>
              <Link to="/politicas-de-privacidade">
                <Help />
                <span>{t("profile-button-6")}</span>
              </Link>
            </li>
            <li>
              <Link to="/regulamento">
                <Help />
                <span>{t("profile-button-7")}</span>
              </Link>
            </li>
            <li>
              <Link to="/" onClick={handleLogout}>
                <Exit />
                <span>{t("profile-button-8")}</span>
              </Link>
            </li>
            <li>
              <button onClick={openModal}>
                <Exit />
                <span>{t("profile-button-9")}</span>
              </button>
            </li>
          </ul>
        </div>
      </section>
      <PopUpExcludedAccount isOpen={isModalOpen} closeModal={closeModal} />
    </DefaultLayout>
  );
}

export default Profile;
